var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, cloneElement, createRef, useRef, useEffect, Children, } from 'react';
import { useUIDSeed } from 'react-uid';
import styled, { css } from 'styled-components';
import { Card } from '../Card';
export var Tabs = styled(function (_a) {
    var children = _a.children, _b = _a.fullWidth, fullWidth = _b === void 0 ? 'small' : _b, _c = _a.defaultSelected, defaultSelected = _c === void 0 ? 0 : _c, onSelected = _a.onSelected, rest = __rest(_a, ["children", "fullWidth", "defaultSelected", "onSelected"]);
    var _d = Children.toArray(children), tabList = _d[0], tabPanels = _d.slice(1);
    var seed = useUIDSeed();
    var _e = useState(defaultSelected), activeTab = _e[0], setActiveTab = _e[1];
    var _f = useState(), focusedRef = _f[0], setFocusedRef = _f[1];
    var tabIds = tabPanels.map(function (_, i) { return seed(i); });
    var tabRefs = tabPanels.map(function () { return createRef(); });
    var loaded = useRef(false);
    var onKeyDown = function (event) {
        if (event.key === 'ArrowLeft' && activeTab > 0) {
            setActiveTab(activeTab - 1);
            setFocusedRef(activeTab - 1);
        }
        if (event.key === 'ArrowRight' && activeTab < tabPanels.length - 1) {
            setActiveTab(activeTab + 1);
            setFocusedRef(activeTab + 1);
        }
    };
    useEffect(function () {
        var _a, _b;
        if (focusedRef !== undefined) {
            (_b = (_a = tabRefs[focusedRef]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [focusedRef]);
    useEffect(function () {
        if (loaded.current) {
            onSelected && onSelected(activeTab);
        }
        else {
            loaded.current = true;
        }
    }, [onSelected, activeTab]);
    return (React.createElement(Card, __assign({}, rest),
        cloneElement(tabList, {
            setActiveTab: setActiveTab,
            fullWidth: fullWidth,
            activeTab: activeTab,
            onKeyDown: onKeyDown,
            tabRefs: tabRefs,
            tabIds: tabIds,
        }),
        tabPanels.map(function (child, index) {
            return cloneElement(child, {
                hidden: activeTab !== index,
                'aria-describedby': tabIds[index],
            });
        })));
})(function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: 0;\n    "], ["\n      padding: 0;\n    "])));
});
var templateObject_1;
